import React, { useEffect, useState } from "react";

import { Grid, Paper } from "@material-ui/core";

import eightAxios from "configs/axiosConfig";
import { GLOBAL_CONFIGURATION_URL } from "configs/constants";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";
import { Formik, Form as FormikForm } from "formik";
import * as Yup from "yup";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { useNotifyContext } from "@Components/Notify";
import { useTranslation } from "react-i18next";

const detailURL = "/configuration/get-config/";

const NewUserRequest = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [newUserRequest, setNewUserRequest] = useState(false);
  const setNotify = useNotifyContext();
  const initialValues = {
    new_user_request: newUserRequest ? newUserRequest : false,
  };

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(detailURL)
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          if (response.data.new_user_request) {
            setNewUserRequest(true);
            setLoading(false);
          } else {
            setNewUserRequest(false);
            setLoading(false);
          }
        } else {
          console.log("error occured.");
        }
      })
      .catch((error) => {
        if (error.response) {
          setLoading(false);
          console.log(error.response);
        }
      });
  };
  const formButtons = [
    {
      type: "submit",
      label: "Save",
      color: "primary",
      saveIcon: <SaveIcon />,
    },
  ];
  const validationSchema = Yup.object({
    new_user_request: Yup.string().required("Choose one option"),
  });

  const handleChange = (event) => {
    let target = event.target;
    let value = target.value === "true";
    setNewUserRequest(value);
  };

  useEffect(() => {
    fetchDetails();
  }, []);
  const handleSubmit = (values, { setSubmitting }) => {
    eightAxios
      .post(GLOBAL_CONFIGURATION_URL, {
        new_user_request: newUserRequest,
      })
      .then(() => {
        setNotify({
          isOpen: true,
          message: "Successfully saved!",
          type: "success",
        });
        setSubmitting(false);
      })
      .catch((error) => {
        setNotify({
          isOpen: true,
          message: error.response.data.message,
          type: "error",
        });
        setSubmitting(false);
      });
  };

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Grid>
      <Paper
        className={classes.filterPaper}
        variant="outlined"
        style={{ backgroundColor: "#dedede" }}
      >
        {t("New User Request Change Configuration")} <br />
      </Paper>
      <Paper className={classes.filterPaper} variant="outlined">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => {
            return (
              <FormikForm>
                <Grid
                  container
                  className={classes.formContainer}
                  direction="row"
                  spacing={2}
                >
                  <Grid item>
                    <label>
                      <input
                        style={{ marginTop: "5px", marginBottom: "10px" }}
                        type="radio"
                        name="new_user_request"
                        value={true}
                        checked={newUserRequest === true}
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          margin: 3,
                        }}
                      >
                        {t("Active")}
                      </span>
                      <div></div>
                    </label>
                    <label>
                      <input
                        style={{ marginTop: "5px", marginBottom: "20px" }}
                        type="radio"
                        name="new_user_request"
                        value={false}
                        checked={newUserRequest === false}
                        onChange={handleChange}
                      />
                      <span
                        style={{
                          fontWeight: 800,
                          color: "black",
                          margin: 3,
                        }}
                      >
                        {t("Inactive")}
                      </span>
                      <br></br>
                    </label>
                    Note: To activate or deactivate “New User Request Link“ on
                    iOS Mobile App Login page
                  </Grid>
                </Grid>
                <Grid container justify="flex-start" spacing={3}>
                  {formButtons.map((formButton, index) => {
                    return (
                      <Grid key={index} item xs={12} sm={6} md={4} lg={1}>
                        <Button
                          style={{ textTransform: "capitalize" }}
                          type={formButton.type}
                          variant="contained"
                          color={formButton.color}
                          disabled={formik.isSubmitting}
                          startIcon={<SaveIcon />}
                          fullWidth
                        >
                          {formButton.label}
                        </Button>
                      </Grid>
                    );
                  })}
                </Grid>
              </FormikForm>
            );
          }}
        </Formik>
      </Paper>
    </Grid>
  );
};

export default NewUserRequest;
